



























import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import Selector from '@ui/Inputs/Selector'
import TagBar from '@ui/TagBar'
import sort from  '@utils/sort.coffee'

settings =
  name: 'ListingAudiencePersonaSelector'

  vue:
    props: ['selectedKeys', 'theme', 'actions', 'options']
    components: { Selector, TagBar }

    data: ->
      scoreType: @options?.target?.audience?.score_type || 'score'

    computed:
      target: -> @options?.target || {}
      audienceTarget: -> @target.audience || {}

      listingAudiences: ->
        data = @marketplace.listing?.unacast_persona_segments
        order = @marketplace.listing?.promoted?.unacast_persona_segments
        listingAudienceOptions = @hashToElementUIOptions data, order

        options = listingAudienceOptions.map((audience) ->
          {
            key: audience.id,
            value: audience.name,
            type: 'listing_audience_persona',
            sortBy: "#{audience.id} #{audience.name}"
          }
        )
        # options.sort((a, b) -> a.value > b.value)
        options

      selectorOptions: ->
        {
          searchBoxPlaceholder: 'Search by name',
          selectOptionsTitle: false,
        }

    methods:
      hiScoreType: (value) ->
        @actions.setScoreType value

      clearSearch: ->
        @$refs.selector.clearSearch()

export default VueOptions.vue settings
